import React, { useContext } from 'react';
import { Row, Col, Container, Accordion, Badge, useAccordionButton, AccordionContext } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import classNames from 'classnames';

import seo from '../../../assets/images/Company2.jpeg';



// types
import { Feature, CrmFeatures } from './types';

// images

type FeaturesProps = {
    features: Feature[];
    crmFeatures: CrmFeatures[]
    containerClass?: string;
};

type CustomToggleProps = {
    children: React.ReactNode;
    eventKey: string;
    containerClass: string;
    linkClass: string;
    callback?: (eventKey: string) => void;
};

const CustomToggle = ({ children, eventKey, linkClass, callback }: CustomToggleProps) => {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
        <Link
            to="#"
            className={classNames(linkClass, {
                collapsed: !isCurrentEventKey,
            })}
            onClick={decoratedOnClick}
        >
            {children}
        </Link>
    );
};

const FeaturesList = ({ item }: { item: Feature }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'row', minHeight: '200px' }} className={item.containerClass}>
            <span
                className={classNames(
                    'bg-soft-' + item.variant,
                    'avatar',
                    'avatar-sm',
                    'rounded-lg',
                    'icon',
                    'icon-with-bg',
                    'icon-xs',
                    'text-' + item.variant,
                    'me-3',
                    'flex-shrink-0'
                )}
            >
                <FeatherIcon icon={item.avatar} className={classNames('icon-dual-' + item.variant)} />
            </span>
            <div className="flex-grow-1">
                <h4 className="text-dark">{item.title}</h4>
                <div>
                    <ul className="text-muted mt-1 mb-4">
                        {item.description.split("\n").map((point, i) => (
                            <li key={i}>{point}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};



const Features1 = ({ features, crmFeatures, containerClass }: FeaturesProps) => {

    const firstColumnFeatures = features.slice(0, Math.ceil(features.length / 2));
    const secondColumnFeatures = features.slice(Math.ceil(features.length / 2));

    return (
        <>


            {/* <section className={containerClass}>
                <Container>
                    <Row className="justify-content-center">
                        <Col className="text-center">
                            <Badge pill bg="" className="badge-soft-primary px-2 py-1">
                                Features
                            </Badge>
                            <h1 className="display-5 fw-medium">Key Features of SalesTrackify CRM</h1>
                        </Col>
                    </Row>

                    <Row className="pt-4 align-items-start features-3">
                        <Col lg={6} className="d-flex flex-column align-items-center justify-content-center">
                            <div id="features-list" data-aos="fade-up" data-aos-duration="300">
                                {firstColumnFeatures.map((item, index) => (
                                    <FeaturesList key={index} item={item} />
                                ))}
                            </div>
                        </Col>

                        <Col lg={6} className="d-flex flex-column align-items-center justify-content-center">
                            <div id="features-list" data-aos="fade-up" data-aos-duration="300">
                                {secondColumnFeatures.map((item, index) => (
                                    <FeaturesList key={index + firstColumnFeatures.length} item={item} />
                                ))}
                            </div>
                        </Col>
                    </Row>




                </Container>
            </section> */}


            <section className={containerClass}>
                <Container>
                    <Row className="mt-1">
                        <Row className="justify-content-center">
                            <Col className="text-center">
                                {/* <h2 className="fw-semibold mb-4">All-in-One CRM Stack</h2> */}

                                <h2
                                    style={{
                                        fontSize: "48px",
                                        fontWeight: 700,
                                        background: "linear-gradient(90deg, #3b82f6, #60a5fa, #93c5fd)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    All-in-One CRM to Keep Your Sales on Track
                                </h2>
                                <p className="text-muted mb-5">SalesTrackify gives your team everything they need to capture leads, follow up on opportunities and close more deals – all from one central platform.</p>
                            </Col>
                        </Row>

                        {crmFeatures.map((crm, index) => (
                            <Col lg={4} md={6} sm={12} key={index} className="mb-4" data-aos="fade-up" data-aos-delay={index * 100}>
                                <div className="p-4 border bg-white rounded-4 h-100 shadow-sm text-start  hover-shadow transition border border-primary p-3 border-2" >
                                    <div className="d-flex align-items-center mb-2">
                                        <div className="me-3 fs-3">{crm.icon}</div>

                                        <h5 className="mb-0 fw-bold text-dark">{crm.title}</h5>
                                    </div>
                                    <ul className="list-unstyled mt-3 mb-0 text-muted small">
                                        {crm.features.map((feat, idx) => (
                                            <li key={idx} className="mb-2 d-flex align-items-start">
                                                <FeatherIcon icon="check-circle" size={14} className="me-2 text-success mt-1" />
                                                {feat}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </Col>
                        ))}



                    </Row>
                </Container>
            </section>



            <section className="py-5" style={{
                // background: "linear-gradient(135deg, #eef2ff 0%, #f8fafc 100%)",
                paddingTop: "80px",
                paddingBottom: "80px",
            }}>
                <div className="container py-5">
                    <Row className="align-items-center">

                        <Col lg={5} className="mb-4 mb-lg-0">
                            <div
                                style={{
                                    // background: "linear-gradient(135deg, #99c0ff, #8ca3ff, #a884ff)",
                                    borderRadius: "20px",
                                    padding: "20px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <img
                                    src={seo}
                                    alt="CoreScripts CEO"
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        borderRadius: "16px",
                                    }}
                                />
                            </div>
                        </Col>

                        {/* RIGHT SIDE - CONTENT */}
                        <Col lg={7}>
                            <h1
                                className="fw-bold"
                                style={{

                                    fontSize: "42px",
                                    color: "#0f172a",
                                    lineHeight: "1.2",
                                }}
                            >
                                Built by <br />
                                <span style={{ color: "#2563eb" }}> CoreScripts Technologies Ltd</span>
                            </h1>

                            <p className="text-muted fs-5 mt-3" style={{ maxWidth: "650px" }}>
                                SalesTrackify is developed by CoreScripts Technologies Ltd, a UK-based
                                software company delivering bespoke software solutions and full-cycle
                                product engineering services. With a strong focus on reliability,
                                scalability and data security, our team ensures SalesTrackify remains
                                a trusted platform for growing businesses.
                            </p>

                            {/* QUOTE */}
                            <div className="mt-4 p-3 ps-4 border-start"
                                style={{ borderColor: "#3b82f6" }}
                            >
                                <p className="fs-5" style={{ color: "#0f172a" }}>
                                    “Our goal is to build technology that empowers businesses to automate,
                                    scale and grow with confidence — backed by high-quality engineering
                                    and reliable systems.”
                                </p>
                                <h6 className="fw-bold mb-0">CoreScripts Technologies Ltd</h6>
                            </div>


                        </Col>
                    </Row>
                </div>
            </section>




            <section className="py-5" style={{ backgroundColor: "#f0f6ff" }}>
                <div className="container text-center py-5">
                    <h2
                        className="fw-bold mb-3"
                        style={{
                            fontSize: "35px",
                            background: "linear-gradient(90deg, #2563eb, #3b82f6, #60a5fa)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                        }}
                    >
                        See SalesTrackify in Action
                    </h2>


                    <p className="text-muted fs-5 mx-auto mb-4" style={{ maxWidth: "750px" }}>
                        Experience how SalesTrackify can simplify your sales operations and support your next stage of growth.
                    </p>


                    <div className="d-flex justify-content-center gap-3 mt-4 flex-wrap">
                        <a
                            href="/contact"
                            className="btn btn-primary px-4 py-2 rounded-pill shadow-sm fw-semibold"
                            style={{ fontSize: "16px" }}
                        >
                            Request a Demo
                        </a>
                    </div>
                </div>
            </section>

        </>
    );
};


export default Features1;
